var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import dayjs from 'dayjs';
export var analySend = function (eventName, params) {
    var _a, _b;
    (_a = window.webAanlytics2020) === null || _a === void 0 ? void 0 : _a.track(eventName, __assign({
        client_times: (_b = dayjs().format('YYYY-MM-DD HH:mm:ss')) !== null && _b !== void 0 ? _b : ''
    }, params));
};
